export default "__VITE_ASSET__D10iVzr7__"